import styled from 'styled-components'

export const CheckBoxDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5vh;
`
export const CheckBoxTitle = styled.span`
  font-size: 1.7vh;
`
